import { Application, Controller } from "./stimulus.js"
import { v4 as uuidv4 } from 'uuid';


window.Stimulus = Application.start()

Stimulus.register("nav", class extends Controller {
  static targets = [ "mobileMenu" ]

  openMobileMenu(event) {
    event.preventDefault();
    this.mobileMenuTarget.classList.remove("hidden");
  }

  closeMobileMenu(event) {
    event.preventDefault();
    this.mobileMenuTarget.classList.add("hidden");
  }

  closeMobileMenuWithDefault(event) {
    this.mobileMenuTarget.classList.add("hidden");
  }
})

Stimulus.register("cart-line-item", class extends Controller {
  static targets = [ "addon" ]

  delete(event) {
    event.preventDefault();

    let parentItemId = event.params.id;
    let url = event.params.url;
    let sectionId = event.params.sectionId;

    const lineItems = this.addonTargets.map(x => x.dataset.lineItemKey);
    const allLineItems = [parentItemId].concat(lineItems);
    this.updateQuantity(allLineItems, 0, url, sectionId);
  }

  changedQuantity(event) {
    event.preventDefault();
    
    let parentItemId = event.params.id;
    let url = event.params.url;
    let sectionId = event.params.sectionId;
    let newQuantity = event.currentTarget.value; 

    const lineItems = this.addonTargets.map(x => x.dataset.lineItemKey);
    const allLineItems = [parentItemId].concat(lineItems);
    this.updateQuantity(allLineItems, newQuantity, url, sectionId);
  }

  updateQuantity(lines, quantity, url, sectionId) {
    let config = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': `application/json` }
    };

    const contentToSend = {};
    contentToSend["updates"] = {};
    lines.forEach((line) => {
      contentToSend["updates"][line] = quantity;
    });
    contentToSend["sections"] = sectionId;

    const body = JSON.stringify(contentToSend);
    //const body = JSON.stringify({
    //  updates: {
    //    [line]: 

    //  }
    //  line,
    //  quantity,
    //  sections: sectionId
    //});

    fetch(`${url}`, {...config, ...{ body }})
      .then((response) => {
        if (response.status === 200) {
          return response.text();
        } else {
          throw new Error("Error, not removed");
        }
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        
        const newSectionHTML = parsedState.sections[sectionId]; 

        const destination = document.getElementById(`shopify-section-${sectionId}`);
        destination.innerHTML = newSectionHTML;
      })
      .catch((error) => {
        this.dispatch("fail", { detail: { customMessage: "We're so sorry, there was an error removing that item from the cart, please try again." } })
      });
  }

})

Stimulus.register("dialogue-box", class extends Controller {
  static targets = [ "dialogueBox" ]
  static values = { isOpen: { type: Boolean, default: false } }

  toggle(event) {
    event.preventDefault();
    if (this.isOpenValue) {
      this.isOpenValue = false;
      this.dialogueBoxTarget.hidden = true;
    } else {
      this.isOpenValue = true;
      this.dialogueBoxTarget.hidden = false;
    }
  }

})

Stimulus.register("read-more", class extends Controller {
  static targets = [ "summary", "mainDescription", "toggleButton" ]
  static values = { isOpen: { type: Boolean, default: false } }

  toggle(event) {
    event.preventDefault();
    if (this.isOpenValue) {
      this.isOpenValue = false;
      this.summaryTarget.classList.remove("hidden");
      this.mainDescriptionTarget.classList.add("hidden");
      this.toggleButtonTarget.innerText = "Read More...";
    } else {
      this.isOpenValue = true;
      this.summaryTarget.classList.add("hidden");
      this.mainDescriptionTarget.classList.remove("hidden");
      this.toggleButtonTarget.innerText = "- Read Less -";
    }
  }

})

Stimulus.register("cart-notification", class extends Controller {
  static targets = [ "notification", "defaultMessage", "customMessage" ]
  static values = { selfDestructionTimer: Number }

  open(event) {
    event.preventDefault();
    this.customMessageTarget.innerHTML = "";

    if(event.detail.customMessage) {
      this.defaultMessageTarget.hidden = true;
      this.customMessageTarget.hidden = false;
      this.customMessageTarget.innerHTML = event.detail.customMessage;
    } else {
      this.defaultMessageTarget.hidden = false;
    }

    this.notificationTarget.hidden = false;

    this.clearTimeout();

    this.selfDestructionTimerValue = setTimeout(() => {
      this.close(event)
    }, 10000);
  }

  close(event) {
    event.preventDefault();
    this.notificationTarget.hidden = true;
    this.customMessageTarget.hidden = true;
    this.defaultMessageTarget.hidden = true;
    this.customMessageTarget.innerHTML = "";

    clearTimeout();
  }
  
  clearTimeout() {
    if (this.selfDestructionTimerValue) {
      clearTimeout(this.selfDestructionTimerValue);
    }
  }
})

Stimulus.register("cart-page", class extends Controller {
  static values = { clearAll: { type: Boolean, default: false }, clearAllUrl: { type: String, default: "" } }

  initialize() {
    this.clearAll();
  }

  // this is a nuke option that we created in case the cart has only oprhaned addon products.
  clearAll() {
    const config = {
      method: 'POST'
    };

    // clear the cart and then reload the page
    fetch(this.clearAllUrlValue, config)
      .then(() => {
        console.log("cleared cart");
        console.log("reloading...");
        location.reload();
      });
  }

})

Stimulus.register("cart", class extends Controller {
  static targets = [ "mainMessage", "loadingMessage", "addToCartButton", "price" ]
  static values = { loading: { type: Boolean, default: false } }

  loadingValueChanged() {
    if (this.loadingValue) {
      this.mainMessageTarget.hidden = true;
      this.loadingMessageTarget.hidden = false;
    } else {
      this.loadingMessageTarget.hidden = true;
      this.mainMessageTarget.hidden = false;
    }
  }

  updateAddToCartButton({ detail: { availability: availability } }) {
    let mainMessage = "Add to Cart"
    if (availability == "available") {
      mainMessage = "Add to Cart";
      this.addToCartButtonTarget.disabled = false;
    } else if(availability === "unavailable") {
      mainMessage = "Unavailable";
      this.addToCartButtonTarget.disabled = true;
      this.priceTarget.innerHTML = "";
    } else if(availability == "sold out") {
      mainMessage = "Sold Out";
      this.addToCartButtonTarget.disabled = true;
    } else {
      mainMessage = "Add to Cart";
      this.addToCartButtonTarget.disabled = false;
    }
    this.mainMessageTarget.innerHTML = mainMessage;
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }
  
  addToCart(event) {
    event.preventDefault();

    const cartAddUrl = event.params.cartAddUrl;

    // form data 
    const form = event.currentTarget.form;
    const formData = new FormData(form);
    const cartItemsToAdd = this.#extractFormDataForAddToCartRequest(formData);

    // hardcoded ID representing the cart, shopify will return the updated HTML if successful.
    const sectionIds = ["cart-icon", "cart-icon-mobile"];

    let data = {
      'items': cartItemsToAdd,
      'sections': sectionIds
    };

    const config = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': `application/javascript`
      },
      body: JSON.stringify(data)
    }

    this.#sendAddToCartRequest(cartAddUrl, config, sectionIds, form);
  }

  #extractFormDataForAddToCartRequest(formData) {
    const formAddonData = formData.getAll("addon");
    const baseProductId = formData.get("id");
    const baseProductQuantity = formData.get(`quantity-${baseProductId}`); 

    // if there are addons on the cart page, otherwise
    // don't treat it like an addon.
    if(formAddonData > 0) {
      // this id is necessary for the cross-sell feature.
      const productIdInternal = uuidv4().slice(-12);

      const addons = formAddonData.map(addon => {
        return {
          'id': addon,
          'quantity': baseProductQuantity,
          'properties': {
            'id': productIdInternal,
            '_addon': "true"
          }
        }
      }); 

      let parsedProperties = {};
      for(let pair of formData.entries()) {
        const titleSplit = pair[0].split("-");
        const identifier = titleSplit.shift();
        const properties = [];
        if (identifier === "property") {
          let id = titleSplit.join(" ");
          parsedProperties[id] = pair[1];
        }
      }

      parsedProperties['id'] = productIdInternal;

      const items = addons.concat([{
        'id': productId,
        'quantity': baseProductQuantity,
        'properties': parsedProperties
      }]);
      return items;
    } else {
      let parsedProperties = {};
      for(let pair of formData.entries()) {
        const titleSplit = pair[0].split("-");
        const identifier = titleSplit.shift();
        const properties = [];
        if (identifier === "property") {
          let id = titleSplit.join(" ");
          parsedProperties[id] = pair[1];
        }
      }

      return [{
        'id': baseProductId,
        'quantity': baseProductQuantity,
        'properties': parsedProperties
      }];
    }
  }

  #sendAddToCartRequest(cartAddUrl, config, sectionIds, form) {
    this.loadingValue = true;

    fetch(cartAddUrl, config)
        .then(response => response.json())
        .then((state) => {
          if (state.status === 422) {
            this.dispatch("fail", { detail: { customMessage: state.description } })
            throw new Error('error thrown already');
          } else {
            sectionIds.forEach(sectionId => {
              const newSectionHTML = state.sections[sectionId]; 
              const newInnerHTML = this.getSectionInnerHTML(newSectionHTML, "#" + sectionId);

              const destination = document.getElementById(sectionId);
              destination.innerHTML = newInnerHTML;
            });

            form.reset();
            this.dispatch("success");
          }
        })
        .catch((error) => {
          if (error.message !== 'error thrown already') {
            this.dispatch("fail");
          }
        })
        .finally(() => {
          this.loadingValue = false;
        })
  }
})

Stimulus.register("slide-show", class extends Controller {
  static targets = [ "slide", "slideItem", "slideBox" ]
  static values = { position: { type: Number, default: 0 } }

  initialize() {
    this.slideItemTargets[this.positionValue].scrollIntoView({ block: 'nearest', inline: 'start' });
  }

  slideItemTargetConnected(slideItem) {
    let options = {
      root: this.slideBoxTarget,
      rootMargin: '0px',
      threshold: 1.0
    }

    let observer = new IntersectionObserver(this.updateSlide.bind(this));
    observer.observe(slideItem);
  }

  updateSlide(entries, observer) {
    entries.forEach((entry) => {
      if(entry.isIntersecting) {
        this.positionValue = entry.target.dataset.slideNumber;
      }
    });
  }

  next() {
    let newPosition = this.positionValue + 1;

    if (newPosition > (this.slideItemTargets.length - 1)) {
      this.positionValue = 0;
      this.slideBoxTarget.scrollTo({top: 0, left: 0, behavior: "smooth"});
    } else {
      this.positionValue = newPosition;
      this.slideBoxTarget.scrollBy({top: 0, left: 1, behavior: "smooth"});
    }
  }

  previous() {
    let newPosition = this.positionValue - 1;

    if (newPosition < 0) {
      let lastPosition = (this.slideItemTargets.length - 1)
      this.positionValue = lastPosition;
      this.slideBoxTarget.scrollTo({top: 0, left: this.slideBoxTarget.scrollWidth, behavior: "smooth"});

    } else {
      this.positionValue = newPosition;
      this.slideBoxTarget.scrollBy({top: 0, left: -1, behavior: "smooth"});
    }
  }
})

Stimulus.register("variants", class extends Controller {
  static targets = [ "option", "option1", "option2", "option3" ]
  static values = { variantData: Array, selectedVariant: String }

  initialize() {
    this.getVariantData();
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(document.body.querySelector('[type="application/json"]').textContent);
  }

  updateVariantStatuses(event) {
    let selectedOption1 = this.option1Targets.find(option1 => option1.getAttribute("aria-selected") === "true");
    let selectedOption2 = this.option2Targets.find(option2 => option2.getAttribute("aria-selected") === "true");
    let selectedOption3 = this.option3Targets.find(option3 => option3.getAttribute("aria-selected") === "true");

    this.option1Targets.forEach(currentOption1 => {
      let disabled = true;
      this.variantData.forEach(variant => {
        // TODO: renamed element.dataset.variantName to element.dataset.optionName
        if(variant.option1 === currentOption1.dataset.variantName && variant.available) {
          disabled = false
        }
      });
      currentOption1.setAttribute('aria-disabled', disabled);
    });

    this.option2Targets.forEach(currentOption2 => {
      let disabled = true;
      this.variantData.forEach(variant => {
        // TODO: renamed element.dataset.variantName to element.dataset.optionName
        if(variant.option1 === selectedOption1.dataset.variantName 
          && variant.option2 === currentOption2.dataset.variantName 
          && variant.available) {
          disabled = false
        }
      });
      currentOption2.setAttribute('aria-disabled', disabled);
    });

    this.option3Targets.forEach(currentOption3 => {
      let disabled = true;
      this.variantData.forEach(variant => {
        // TODO: renamed element.dataset.variantName to element.dataset.optionName
        if(variant.option1 === selectedOption1.dataset.variantName 
          && variant.option2 === selectedOption2.dataset.variantName 
          && variant.option3 === currentOption3.dataset.variantName
          && variant.available) {
          disabled = false
        }
      });
      currentOption3.setAttribute('aria-disabled', disabled);
    });

    let selectedVariantAvailability = "unavailable";
    this.variantData.forEach(variant => {
      // TODO: renamed element.dataset.variantName to element.dataset.optionName
      if(variant.option1 === selectedOption1.dataset.variantName 
        && variant.option2 == selectedOption2.dataset.variantName 
        && variant.option3 == selectedOption3.dataset.variantName
        && variant.available) {
        selectedVariantAvailability = "available";
      } else if(variant.option1 === selectedOption1.dataset.variantName 
        && variant.option2 == selectedOption2.dataset.variantName 
        && variant.option3 == selectedOption3.dataset.variantName
        && variant.available == false) {
        selectedVariantAvailability = "sold out";
      }
    });
    
    // "available"
    // "unavailable"
    // "sold out"
    this.dispatch("updatedVariant", { detail: { availability: selectedVariantAvailability } });
    this.updateVariant(event, selectedVariantAvailability);
  }

  updateVariant({ params: { productUrl, sectionId } }, variantStatus) {
    if(variantStatus === "available" || variantStatus === "sold out") {
      let selectedOptions = this.optionTargets.reduce((values, element) => {
        if (element.getAttribute("aria-selected") === "true") {
          values.push(element.dataset.variantName);
        }
        return values;
      }, []);

      let newVariant = this.variantData.find(element => {
        return !element.options.map((option, index) => {
          return option === selectedOptions[index];
        }).includes(false);
      });
      
      this.selectedVariantValue = newVariant.id;

      fetch(`${productUrl}?variant=${this.selectedVariantValue}&section_id=${sectionId}`)
        .then((response) => response.text())
        .then((responseText) => {
            const destination = document.getElementById(`shopify-section-${sectionId}`);
            destination.innerHTML = responseText;
            window.history.pushState({}, "", `${productUrl}?variant=${this.selectedVariantValue}`);
          });
      }
  }
});

Stimulus.register("variant-selector", class extends Controller {
  static targets = [ "variant" ]
  static values = { variantOption: String }

  updateOption(event) {
    event.preventDefault();
    this.variantOptionValue = event.currentTarget.innerHTML;
    this.changeSelectedOption()
  }

  changeSelectedOption() {
    this.variantTargets.forEach((element, index) => {
      if (element.innerHTML === this.variantOptionValue) {
        element.setAttribute('aria-selected', true);
      } else {
        element.setAttribute('aria-selected', false);
      }
    })
  }
});

Stimulus.register("product-quantity", class extends Controller {
  static targets = [ "textField" ]
  static values = { quantity: { type: Number, default: 1 } }

  quantityValueChanged() {
    this.textFieldTarget.value = this.quantityValue;
  }

  decrement(event) {
    event.preventDefault();

    let newQuantity = this.quantityValue - 1;

    if (newQuantity >= 1) {
      this.quantityValue = newQuantity;
    }
  }

  increment(event) {
    event.preventDefault();
    
    let newQuantity = this.quantityValue + 1;
    this.quantityValue = newQuantity;
  }
});

Stimulus.register("product", class extends Controller {
  static targets = [ "textField" ]
  static values = { quantity: { type: Number, default: 1 } }

  connect() {

  }

});

Stimulus.register("collection-sort-by", class extends Controller {
  static targets = [ ];
  static values = { };

  changeSortBy(event) {
    let id = event.params.id;
    let url = event.params.collectionUrl;
    let sectionId = event.params.sectionId;
    let newSortBy = event.currentTarget.value;

    fetch(`${url}?sort_by=${newSortBy}&section_id=${sectionId}`)
      .then((response) => response.text())
      .then((responseText) => {
          const url = new URL(window.location);
          url.searchParams.set("sort_by", newSortBy);
          url.searchParams.delete("page");
          window.history.pushState({}, '', url);
          const destination = document.getElementById(`shopify-section-${sectionId}`);
          destination.innerHTML = responseText;
        });
  }
});

Stimulus.register("custom-message-text", class extends Controller {
  static targets = [ "characterCounter", "textField", "errorMessage" ]
  static values = { maxCharacters: { type: Number, default: 300 } }

  clearCounter() {
    this.characterCounterTarget.innerHTML = 0;
    this.messageToCounter(this.textFieldTarget.value);
  }
  
  updateCharacterCounter(event) {
    let message = event.currentTarget.value;
    this.messageToCounter(message);
  }

  messageToCounter(message) {
    let totalCharacterLength = message.length;
    this.characterCounterTarget.innerHTML = totalCharacterLength;
    if (totalCharacterLength >= this.maxCharactersValue) {
      this.errorMessageTarget.classList.remove("hidden");
    } else {
      this.errorMessageTarget.classList.add("hidden");
    }
  }
});

Stimulus.register("important-notice", class extends Controller {
  static targets = [ "noticeBox" ];
  static noticeBoxCookieName = "noticeBoxClosed";

  initialize() {
    let noticeBoxCookie = this.getCookie(this.noticeBoxCookieName);
    if (noticeBoxCookie !== "0") {
      this.openNoticeBox();
    }
  }

  getCookie(cname) {
    let name = cname + "=";
    let ca = document.cookie.split(';');
    for(let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  openNoticeBox(event) {
    if (event) {
      event.preventDefault();
    }
    this.noticeBoxTarget.classList.remove("hidden");
  }

  closeNoticeBox(event) {
    event.preventDefault();
    this.noticeBoxTarget.classList.add("hidden");
  }

  closeNoticeBox(event) {
    event.preventDefault();
    this.noticeBoxTarget.classList.add("hidden");

    // Cookie Date
    let cookieDate = new Date();
    // Add one day
    cookieDate.setDate(cookieDate.getDate() + 1);
    let expires = "expires=" + cookieDate.toUTCString();
    let cookieValue = this.noticeBoxCookieName + "=" + "0" + ";" + expires + ";path=/";
    document.cookie = cookieValue;
  }

});

